export interface NotificationConfig {
  id: string,
  type: NotificationConfigType,
  values: {
    inApp: boolean,
    sms: boolean,
  },
}

export enum NotificationConfigType {
  FIRST_LOAD = 'FIRST_LOAD', // includes NotificationType.FIRST_LOAD
  ORDERS_PLACED_ONLINE = 'ORDERS_PLACED_ONLINE', // includes NotificationType.ORDER_BOT_SUCCESS + NotificationType.ORDER_BOT_IN_PROCESS
  ORDERS_MODIFIED_ONLINE = 'ORDERS_MODIFIED_ONLINE', // includes NotificationType.ORDER_MODIFICATION_ACCEPTED + NotificationType.ORDER_MODIFICATION_PROCESSING + NotificationType.ORDER_MODIFICATION_ACCEPTED_WITH_CONSULT
  LAST_LOAD = 'LAST_LOAD', // includes LAST_LOAD, LAST_LOAD_WITH_PLUS_LOAD
}

export function formatNotifcationTypeHeadline(type: NotificationConfigType): string {
  const mappings = {
    FIRST_LOAD: `First Truck In Transit`,
    ORDERS_PLACED_ONLINE: `Orders I've Placed Online`,
    ORDERS_MODIFIED_ONLINE: `Orders I've Modified Online`,
    LAST_LOAD: `Last Truck In Transit`,
  }
  return mappings[type]
}

export function formatNotifcationTypeDescription(type: NotificationConfigType): string {
  const mappings = {
    FIRST_LOAD: `Send me a notification when the first truck for an order is on its way`,
    ORDERS_PLACED_ONLINE: `Send me notifications when I place an order online`,
    ORDERS_MODIFIED_ONLINE: `Send me notifications when I modify an order online`,
    LAST_LOAD: `Send a notification when the last truck (incl. Plus Load) is on its way`,
  }
  return mappings[type]
}

export enum NotificationConfigDevice {
  InApp = 'inApp',
  SMS = 'sms',
}
